// UI
import PurchaseOrderCreateEdit from '@/components/purchase_orders/PurchaseOrderCreateEdit'
import PurchaseOrderDisplay from '@/components/purchase_orders/PurchaseOrderDisplay'
import ScrollableScreen from '@/components/ui/ScrollableScreen'
import NotFound from '@/components/ui/NotFound'

// UI Components
import Badge from '@/components/ui/Badge'

// Hook
import usePurchaseOrder from '@/components/purchase_orders/usePurchaseOrder'
import useMe from '@/hooks/useMe'

// React
import { useState } from 'react'

// Router
import { useParams } from 'react-router-dom'

// Status name
import {
    statusName,
    statusDotColor,
} from '@/components/purchase_orders/purchaseOrderStatuses'

// Mantine
import { ActionIcon, Menu } from '@mantine/core'

// UI
import InvlevelHistory from '@/components/ui/InvlevelHistory'

import ActivityLog from '@/components/ui/ActivityLog'

// Icons
import { DotsVertical } from 'tabler-icons-react'
import { IconHistory } from '@tabler/icons-react'

export default function IndexPurchaseOrders() {
    // Router

    const { id } = useParams()
    const { isAdmin } = useMe()

    // Edit mode
    const [isEditing, setIsEditing] = useState(false)

    // Hook
    const { purchaseOrder, handlers, isSaving, refetch, changeStatus } =
        usePurchaseOrder(id)

    if (purchaseOrder?.id && !isAdmin && purchaseOrder?.location_id !== 1) {
        return <NotFound />
    }

    const rightSection = (
        <div className="flex gap-3 items-center">
            <Badge size="md" color={statusDotColor(purchaseOrder.status)}>
                {statusName(purchaseOrder.status)}
            </Badge>

            {purchaseOrder?.id && (
                <ActivityLog
                    subjectType="purchase-orders"
                    subjectId={purchaseOrder.id}
                />
            )}

            {!isEditing && (
                <InvlevelHistory purchase_order_id={purchaseOrder?.id}>
                    {(openHistory) => (
                        <Menu position="bottom-end">
                            <Menu.Target>
                                <ActionIcon variant="default" size="lg">
                                    <DotsVertical size={16} />
                                </ActionIcon>
                            </Menu.Target>

                            <Menu.Dropdown>
                                {purchaseOrder?.status !== 'closed' && (
                                    <Menu.Item onClick={() => changeStatus('closed')}>
                                        Marquer comme terminé
                                    </Menu.Item>
                                )}

                                {purchaseOrder?.status !== 'canceled' && (
                                    <Menu.Item onClick={() => changeStatus('canceled')}>
                                        Marquer comme annulé
                                    </Menu.Item>
                                )}

                                {purchaseOrder?.status !== 'open' && (
                                    <Menu.Item onClick={() => changeStatus('open')}>
                                        Marquer comme à réceptionner
                                    </Menu.Item>
                                )}

                                {purchaseOrder?.status === 'open' && (
                                    <Menu.Item onClick={() => setIsEditing(true)}>
                                        Modifier
                                    </Menu.Item>
                                )}

                                <Menu.Item
                                    leftSection={<IconHistory size={16} />}
                                    onClick={openHistory}
                                >
                                    Historique du stock
                                </Menu.Item>
                            </Menu.Dropdown>
                        </Menu>
                    )}
                </InvlevelHistory>
            )}
        </div>
    )

    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Bons de commande',
            href: '/purchase_orders?status=open',
        },
        {
            label:
                'BC' +
                purchaseOrder.id +
                ' - ' +
                [purchaseOrder?.reference, purchaseOrder?.name].join(' / '),
        },
    ]

    return (
        <ScrollableScreen
            breadcrumbs={breadcrumbs}
            rightSection={rightSection}
        >
            {purchaseOrder?.id && (
                <>
                    {!isEditing && (
                        <div>
                            <PurchaseOrderDisplay
                                openEditMode={() => setIsEditing(true)}
                                purchaseOrder={purchaseOrder}
                                refetch={refetch}
                            />
                        </div>
                    )}

                    {isEditing && (
                        <PurchaseOrderCreateEdit
                            isSaving={isSaving}
                            purchaseOrder={purchaseOrder}
                            handlers={handlers}
                            closeEditMode={() => setIsEditing(false)}
                        />
                    )}
                </>
            )}
        </ScrollableScreen>
    )
}
